import React from 'react'
import iconNames from 'theme/icons'
import {t} from "helpers/language"

export const skill = {
  key: "ADD_ACTIVITY",
  group: 'activities',
  label: t("Add an activity"),
  desc: t("Quickly log or schedule a new call, meeting or task"),
  steps: [
    {
      target: '.header-addButton',
      content: <div>To add an activity <i>Tap The Add Button</i>. You can use this button at any time to add a new contact, activity or quote.</div>,
    },
    {
      target: '.addMenu-addActivity',
      content: <div><i>Tap Add Activity</i> to add a new activity</div>,
      placement: 'left',
      awaitElement: {interval: 100},
    },
    {
      // Inline tooltip in contact dialog
      dummy: true,
      addActivityDialog: true, // sets the page number on the contact dialog
      location: '/diary/activities/calendar',
    },
    {
      title: "Activity Added",
      titleIcon: iconNames.tick,
      titleIconColor: "green",
      content: (
        <div>
          {"Great, you've added your first activity!"}<br/>
          <br/>
          Take a look at your new meeting on the calendar.
        </div>
      ),
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: "Finish",
          primary: true,
          type: "finish",
        },
      ],
    },
  ],
}

export default skill
